export const RECEIVE_MODAL = 'RECEIVE_MODAL'

export const RESET_MODAL = 'RESET_MODAL'
